import React,{Component} from "react";
import "./header/Header.css";
import "../scss/general.css";
import Cookies from "universal-cookie";
import Moment from "moment";
import logo from "./images/loading.gif";
import logoverified from "./images/verified.png";
import Mymodal from './modal';
import config from '../config';
import logoload from "./images/loader.gif";
import BusyModal from "./modalwait";
import paidimage from "./images/paid.jpg";
import logonorecord from "./images/recordnotfound.png";
const cookies = new Cookies();
const axios = require("axios");
const ref = React.createRef();
export default class AdminMedicalEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {input:{},
            apipath:"",
            myitems: [],
            isLoaded: true,
            isForm: "none",
            FormID:"",
            errortext:"",
            errortextb:"",

            errorcss:"",
            remaincolor:"",
            paidlogo:"",
            modalbody:"wait please...",
            modaltitle:"",
            modalfooter:"",
            isOpen:false,
            editED:false,saveED:false,
            CAmt:0,TAmt:0,MAmt:0,RowAmt:0,GAmt:0,c_amt:0,p_amt:0,
            buttonED:false,
            modalbody:config.gvr.mymodal.loadwait,
            modalimage:logoload,
            
            divbutton:"<button onClick={this.handleVerify(0)} style={{background: 'linear-gradient(to bottom , #ffffff 0%, black 100%)'}}>Check / Verify</button>",
            ErrMsg:"", //<img src={logo} alt=""/>,
            ErrMsg2:""
        }
        this.currencyFormat = this.currencyFormat.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleVerify = this.handleVerify.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleUpdateForm = this.handleUpdateForm.bind(this);
        this.handleEditClick = this.handleEditClick.bind(this);

    }
    showModal=()=>
    {
        this.setState({isOpen:true});
    }
    hideModal=()=>
    {
        this.setState({isOpen:false});
    }

    handleEditClick(){
        this.setState({editED:true,saveED:false});
    }
    // handle input change
    handleInputEdit=(e, index)=>{

        let myitems = this.state.myitems;
        myitems[index][e.target.name] = e.target.value;
        this.setState({myitems});
    }
    handleInputEditAmt=(e, index)=>{        
/*        let input = this.state.input;
        let rcolor = "";
        input["Remaining"]=Number(input["Remaining"])-Number(e.target.value)+Number(this.state.p_amt);
        if(Number(input["Remaining"]) < 0)
            rcolor="red";
        else
            rcolor="";*/
        this.handleInputEdit(e, index);
//        this.setState({input,remaincolor:rcolor});

    }
    handleInputEditAmt1=(e, index)=>{        
        let input = this.state.input;
//        let rcolor = "";
        input["Remaining"]=Number(input["Remaining"])+Number(e.target.value);
        this.setState({input});
/*        if(Number(input["Remaining"]) < 0)
            rcolor="red";
        else
            rcolor="";
        this.handleInputEdit(e, index);
        this.setState({input,remaincolor:rcolor});*/

    }
    
  handleInputChange(e){
    this.setState({FormID:e.target.value});
  }
  handleFocus(e){
      e.target.select();
      let input = this.state.input;
      input["Remaining"]=Number(input["Remaining"])-Number(e.target.value);
      this.setState({input});
      //      this.setState({p_amt:Number(event.target.value)});
    }

  componentDidMount()
  {
    this.setState({CAmt:0,TAmt:0,MAmt:0,isForm:"none",apipath:this.props.apipath});

  }
  handleUpdateForm(){

    document.body.style.cursor="wait";

    this.setState({ErrMsg2:<BusyModal/>});

    axios({
      method: 'post',
//      url: cookies.get("phpclass")+'/index.php/user/updatemedicaldetail/',
      url: this.state.apipath +'/index.php/user/updatemedicaldetail/',
      data: this.state.myitems,
      headers: {'Content-Type': 'multipart/form-data'}
    })
    .then((response)=> {
     document.body.style.cursor="default";
     if(response.data==="1")
     { 
            this.setState({ErrMsg2:"",errortextb:"Update has been made successfully",errorcss:"labelsave",editED:false,saveED:true});
     } 
     else
     {   
           this.setState({ErrMsg2:"",errortextb:"Some Error accoured, please try later",errorcss:"labelerror"});
     }
    })
    .catch(function (response) {
         document.body.style.cursor="default";
         this.setState({ErrMsg2:"",errortextb:"Some Error accoured, please try later",errorcss:"labelerror"});

    });
 }

    handleVerify(){
        let input=this.state.input;
        if(input["remaining"]<0)
            this.setState({ErrMsg:"Bill amount is exceeded to the remaining balance."})
        else
        {

            document.body.style.cursor="wait";
            this.setState({buttonED:true});
            axios({
                method: "post",
//                url:    cookies.get("phpclass")+"/index.php/user/approveMedical/"+this.state.FormID,
                url:   this.state.apipath +"/index.php/user/approveMedical/"+this.state.FormID,
                heaer: {"Content-Type":"multipart/for-data"}
            })
            .then((response)=>{
                document.body.style.cursor="default";
                this.setState({buttonED:true,divbutton:<img src={logoverified}/>});
            })
            .catch=()=>{
                document.body.style.cursor="default";
                this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
            };
        }
    }
    currencyFormat(num) {
        let cnum=Number(num);
        return cnum.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
    handleSubmit(){
        this.setState({errortext:"",ErrMsg:<img src={logo} alt=""/>,myitems:[],isForm:"none"});
        if(this.state.FormID.length !== 0)
        {
            document.body.style.cursor="wait";
            axios({
                    method: 'post',
//                    url: cookies.get("phpclass")+'/index.php/user/AdminmedicalForm/'+this.state.FormID,
                    url: this.state.apipath +'/index.php/user/AdminmedicalForm/'+this.state.FormID,
                    headers: {'Content-Type': 'multipart/form-data'}
                })
                .then((response)=> {
                    if(response.data.length == 0)
                    {

                        this.setState({ErrMsg:<img src={logonorecord} alt=""/>});
                        document.body.style.cursor="default";            
                    }
                    else
                    {
                        document.body.style.cursor="default";
                        let input = this.state.input;
                        console.log(response.data);
                        input["Name"] = response.data[0]["NAME"];
                        input["Designation"] = response.data[0]["DESIG"];
                        input["Emp_ID"] = response.data[0]["Emp_Id"];
                        input["Location"] = response.data[0]["location"];
                        input["DateClaim"] = response.data[0]["DateClaim"];
                        input["ClaimID"] = this.state.FormID;
                        input["Ceiling"] = response.data[0]["Ceiling"];
                        input["Remaining"] = response.data[0]["Remaining"];

                        this.setState({input, ErrMsg:"",isLoaded: true, isForm:"block", myitems: response.data, ErrMsgs:"",buttonED: false});
                        if(response.data[0]['status'] === 1)
                            this.setState({paidlogo:paidimage,editED:true,saveED:true, divbutton:<span style={{fontSize:'12pt',color:'red'}}>This claim has already been paid.</span>});
                        else
                            this.setState({paidlogo:"",editED:false,saveED:true,divbutton:<button onClick={this.handleVerify} style={{background: 'linear-gradient(to bottom , #ffffff 0%, black 100%)'}} disabled={this.state.buttonED}>Check / Verify</button>});
                    
                    }
                })
                .catch=()=> {
                    document.body.style.cursor="default";
                    this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});

                }; 
        }
        else
        {
            this.setState({errortext:"Enter Form ID"});
        }

    }
    render(){
        let items=this.state.myitems;
        let Const_date,Med_date,Test_date = "";
        let CAmt = this.state.CAmt;
        let MAmt = this.state.MAmt;
        let TAmt = this.state.TAmt;
        let RowAmt = this.state.RowAmt;
        let GAmt = this.state.GAmt;
        let isForm = this.state.isForm;
        let isLoaded = this.state.isLoaded;
        if(isLoaded)
        {
           return(
            <div width="100%" align="center" >
                <br></br>
                <div className="inner-profile33" >
                    <div className="inner-profile2" >
                        <label>Form ID: </label>
                        <input style={{width:"110px",paddingRight:20}} autoFocus="autofocus" name="EmpID" placeholder="Form Id" onChange={this.handleInputChange} onFocus={ this.handleFocus}/>
                        <button onClick={this.handleSubmit} >Submit</button>
                        <span className="labelerror">{this.state.errortext}</span>
                    </div>
                    <br></br><br></br>

                    <div style={{display:isForm,textAlign:"left",width:"100%"}} >  
                        <div style={{textAlign:"left",width:"60%", float:"left"}} >  
                            <table style={{ width:"70%",  marginTop :75}}>
                                <tbody>
                                    <tr>
                                        <td style={{width:"200px",fontStyle: "normal"}}>Claim ID:</td>
                                        <td style={{width:"300px",textAlign:"left"}}>{this.state.input["ClaimID"]}</td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"200px",fontStyle: "normal"}}>Employee's ID:</td>
                                        <td style={{width:"300px",textAlign:"left"}}>{this.state.input["Emp_ID"]}</td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"200px",fontStyle: "normal"}}>Employee's Name:</td>
                                        <td style={{width:"300px",textAlign:"left"}}>{this.state.input["Name"]}</td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"200px",fontStyle: "normal"}}>Designation:</td>
                                        <td style={{width:"300px",textAlign:"left"}}>{this.state.input["Designation"]}</td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"200px",fontStyle: "normal"}}>Location:</td>
                                        <td style={{width:"300px",textAlign:"left"}}>{this.state.input["Location"]}</td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"200px",fontStyle: "normal"}}>Date:</td>
                                        <td style={{width:"300px",textAlign:"left"}}>{Moment(this.state.input["DateClaim"]).format("DD/MM/YYYY")}</td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"200px",fontStyle: "normal"}}>Ceiling:</td>
                                        <td style={{width:"300px",textAlign:"left"}}>{this.currencyFormat(this.state.input["Ceiling"])}</td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"200px",fontStyle: "normal"}}>Remaining:</td>
                                        <td style={{width:"300px",textAlign:"left", color:this.state.remaincolor}}>{this.currencyFormat(this.state.input["Remaining"])}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div style={{width:"40%", marginTop:"50px", float:"left"}}>
                            <img src={this.state.paidlogo} />
                        </div>
                        <table className="mtable">
                            <thead >
                                <tr>
                                    <th className="mth" rowSpan="2"><p style={{textAlign:'center'}}>PATIENT NAME</p></th>
                                    <th className="mth" rowSpan="2"><p style={{textAlign:'center'}}>RELATION</p></th>
                                    <th className="mth" colSpan="2"><p style={{textAlign:'center'}}> CONSULTATION</p></th>
                                    <th className="mth" colSpan="2"><p style={{textAlign:'center'}}>MEDICINES </p></th>
                                    <th className="mth" colSpan="2"><p style={{textAlign:'center'}}>TESTS/LAB.</p></th>
                                    <th className="mth" rowSpan="2"><p style={{textAlign:'center'}}>TOTAL.</p></th>
                                </tr> 
                                <tr>
                                    <th className="mth">Amount</th>
                                    <th className="mth">Date</th>
                                    <th className="mth">Amount</th>
                                    <th className="mth">Date</th>
                                    <th className="mth">Amount</th>
                                    <th className="mth">Date</th>
                                </tr>
                            </thead>
                            <tbody>
                            {items.map((x, i) => {
                                CAmt += Number(x.Const_amt);
                                TAmt += Number(x.Test_amt);
                                MAmt += Number(x.Med_amt);
                                RowAmt = Number(x.Const_amt)+Number(x.Test_amt)+Number(x.Med_amt);
                                GAmt += RowAmt; // this.state.CAmt+this.state.TAmt+this.state.MAmt 
                                if(Number(x.Const_amt) === 0) 
                                    Const_date= "";
                                else
                                    Const_date=  x.Const_date; //.format("DD/MM/YYYY")
                                if(Number(x.Med_amt) === 0) 
                                    Med_date= "";
                                else
                                    Med_date=x.Med_date; // Moment(x.Med_Date).format("DD/MM/YYYY")
                                if(Number(x.Test_amt) === 0) 
                                    Test_date= "";
                                else
                                    Test_date=x.Test_date; //).format("DD/MM/YYYY")
                                return(
                                    <tr key={i} height="35px">
                                        <td className="mtd" width="165px" >
                                        <input style={{width:155, border:'none'}} value={x.PName} readOnly disabled={this.state.editED}></input>
                                            {/*<span width="175px">{x.PName}</span>*/}
                                        </td>
                                        <td className="mtd" width="80px">
                                            <input style={{width:75, border:'none'}} value={x.Relation} readOnly disabled={this.state.editED}/>
                                        </td>
                                        <td className="mtd" >
                                            <input type="number" style={{width:60, border:'none',textAlign: 'right' }}
                                                name="Const_amt"
                                                disabled={this.state.saveED}
                                                value={Number(x.Const_amt)}
                                                onChange={e=> this.handleInputEditAmt(e,i)}
                                                onBlur={e=> this.handleInputEditAmt1(e,i)}
                                                onFocus={this.handleFocus}
                                            />
                                        </td>
                                        <td className="mtd" >
                                            <input type="date" style={{width:92, border:'none'}}
                                                disabled={this.state.saveED}
                                                name="Const_date"
                                                value={x.Const_date}
                                                onChange={e=> this.handleInputEdit(e,i)}
                                            />
                                        </td>
                                        <td className="mtd" >
                                            <input type="number" style={{width:60, border:'none',textAlign: 'right' }}
                                                name="Med_amt"
                                                disabled={this.state.saveED}
                                                value={Number(x.Med_amt)}
                                                onChange={e=> this.handleInputEditAmt(e,i)}
                                                onBlur={e=> this.handleInputEditAmt1(e,i)}
                                                onFocus={ this.handleFocus}
                                            />
                                        </td>
                                        <td className="mtd" >
                                            <input type="date" style={{width:92, border:'none'}}
                                                disabled={this.state.saveED}
                                                name="Med_date"
                                                value={Med_date}
                                                onChange={e=> this.handleInputEdit(e,i)}
                                            />
                                        </td>
                                        <td className="mtd" >
                                            <input type="number" style={{width:60, border:'none',textAlign: 'right' }}
                                                disabled={this.state.saveED}
                                                name="Test_amt"
                                                value={Number(x.Test_amt)}
                                                onChange={e=> this.handleInputEditAmt(e,i)}
                                                onBlur={e=> this.handleInputEditAmt1(e,i)}
                                                onFocus={ this.handleFocus}
                                            />
                                        </td>
                                        <td className="mtd" >
                                            <input type="date" style={{width:92, border:'none'}}
                                                disabled={this.state.saveED}
                                                name="Test_date"
                                                value={Test_date}
                                                onChange={e=> this.handleInputEdit(e,i)}
                                            />
                                        </td>
                                        <td className="mtd">
                                            <input type="text" style={{width:60, border:'none',textAlign:"right"}}
                                                disabled
                                                value={this.currencyFormat(RowAmt)}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}            
                            <tr style={{height:"40px", border: "1.5px solid rgb(161, 159, 159, 161)"}}>
                                <td className="mtdleft2" colSpan="2">
                                    TOTAL
                                </td>
                                <td className="mtdcenter2" colSpan="2">
                                    {this.currencyFormat(CAmt)}                
                                </td>
                                <td className="mtdcenter2" colSpan="2" >
                                    {this.currencyFormat(MAmt)}
                                </td>
                                <td className="mtdcenter2" colSpan="2">
                                    {this.currencyFormat(TAmt)}
                                </td>
                                <td className="mtdcenter2" colSpan="2">
                                    {this.currencyFormat(GAmt)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div style={{width:"90%", height:"40px",textAlign:"center", marginTop:"5px"}} >
                        <button style={{marginRight:"5px",align:"center",width:"75px"}} className="btn btn-secondary"  disabled={this.state.editED} onClick={this.handleEditClick}>Edit</button>
                        <button  style={{margingLeft:"5px",align:"center",width:"75px"}} className="btn btn-secondary"  disabled={this.state.saveED} onClick={this.handleUpdateForm}>Save</button>
                    </div>
                    <div style={{width:"100%",float:"center",textAlign:"center"}}>
                        <span className={this.state.errorcss}><b>{this.state.errortextb}</b></span>
                    </div>
                </div>
            </div>
            <br></br><br></br><br></br>
            {this.state.ErrMsg}
        </div>  
    );
    }
}
}
